import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
// import { get } from 'session';
import Decimal from 'decimal.js';
import NumberFormat from 'react-number-format';
import { MAX_LIMIT } from 'modules/common/constants';
import { ucwords } from '../../../helper';
import * as actions from '../../../actions';
import * as c from '../../../constant';

function BusinessActivityModal({
  formData,
  setFormData,
  getBusinessLinesList,
  businessLinesList,
  getNecessaryFieldsList,
  necessaryFieldsList,
  businessActivityInfo,
  closeUpdateModal,
  handleOnUpdate,
  detailFormData,
  setDetailFormData,
  formDataQuantityMatrix,
  setFormDataQuantityMatrix,
}) {
  const filteredNecessaryFieldsList = necessaryFieldsList.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = necessaryFieldsList.filter(
    (item) => item.quantity_matrix
  );
  const quantityMatrix = _.get(businessActivityInfo, 'attributes.details.quantity_matrix') || [];
  const multiplierQuantityMatrix = Object.values(quantityMatrix ?? {})
    .flatMap(item => _.isArray(item) ? item : [])
    .reduce((acc, { multiplier, value }) => {
      if (multiplier && !Number.isNaN(value)) {
        acc[multiplier] = +value;
      }
      return acc;
    }, {});

  const validateForm = useFormValidator(formData, {
    business_line_id: 'required',
    capital_amount: 'required',
    gross_amount: 'required',
    industrial_code: 'required',
  });

  // const addCommas = (num) =>
  //   num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, '');

  useEffect(() => {
    getBusinessLinesList();
    if (
      !_.isEmpty(_.get(businessActivityInfo, 'attributes.business_line_id'))
    ) {
      getNecessaryFieldsList({
        business_line_id: _.get(
          businessActivityInfo,
          'attributes.business_line_id'
        ),
        application_status_id: 21 || 0,
      });
    }
  }, []);

  useEffect(() => {
    getNecessaryFieldsList({
      business_line_id: _.get(
        businessActivityInfo,
        'attributes.business_line_id'
      ),
      application_status_id: 21 || 0,
    });
  }, [_.get(businessActivityInfo, 'attributes.business_line_id')]);

  const formatNumberWithCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  useEffect(() => {
    let keyValues = [];
    keyValues = Object.entries(
      _.get(businessActivityInfo, 'attributes.details') || ''
    ).map(([key, value]) => ({
      [key]: value.toString() || '',
    }));

    let finalObject = {};
    const badCallback = (a, i) => Object.assign(a, i);
    finalObject = keyValues.reduce(badCallback, {});

    setFormData({
      ...formData,
      business_line_id: +_.get(
        businessActivityInfo,
        'attributes.business_line_id'
      ),
      capital_amount: formatNumberWithCommas(
        _.get(businessActivityInfo, 'attributes.capital_amount')
      ),
      gross_amount: formatNumberWithCommas(
        _.get(businessActivityInfo, 'attributes.gross_amount')
      ),
      industrial_code: _.get(
        businessActivityInfo,
        'attributes.industrial_code'
      ),
    });

    setDetailFormData({
      ...finalObject,
    });
  }, []);

  // select line
  const handleLineDropDownChange = (key) => (e) => {
    setDetailFormData({});
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      industrial_code: e.industrial_code,
    });

    getNecessaryFieldsList({
      business_line_id: e.value,
      application_status_id: 21 || 0,
    });
  };

  const selectBusinessLineId = businessLinesList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
    industrial_code: _.get(x, 'attributes.code'),
  }));

  const findBusinessLineValue =
    selectBusinessLineId.find(
      (item) => +_.get(formData, 'business_line_id') === +item.id
    ) || '';

  // select necessary field
  const handleOfficeTypeDropDownChange = (key) => (e) => {
    setDetailFormData({
      ...detailFormData,
      [key]: e ? e.value : '',
    });
  };

  const selectOptions = (list) => {
    const newList = [];

    list.map((data) => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const handleChangeCapitalAmount = (e) => {
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleOnChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const handleOnChangeDetail = (key) => (e) => {
    setDetailFormData({
      ...detailFormData,
      [key]: _.get(e, 'target.value'),
    });
  };

  useEffect(() => {
    if (!_.isEmpty(businessActivityInfo)) {
      setFormDataQuantityMatrix({
        ...formDataQuantityMatrix,
        ...multiplierQuantityMatrix,
      });
    }
  }, []);

  const onChangeQuantityMatrix = (key, value) => {
    setFormDataQuantityMatrix({
      ...formDataQuantityMatrix,
      [key]: value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  return (
    <div className="">
      <div className="row">
        <div className="col-4">
          <label className="text-primary font-weight-bold">
            Line of Business : &nbsp;
          </label>
          <p>
            {_.get(
              businessActivityInfo,
              'attributes.initial_data.line_of_business'
            )}
          </p>
        </div>
        <div className="col-4">
          <label className="text-primary font-weight-bold">
            Number of Units : &nbsp;
          </label>
          <p>
            {_.get(businessActivityInfo, 'attributes.initial_data.no_of_units')
              ? parseFloat(
                  _.get(
                    businessActivityInfo,
                    'attributes.initial_data.no_of_units'
                  ) || 0,
                  10
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : '0.00'}
          </p>
        </div>
        <div className="col-4">
          <label className="text-primary font-weight-bold">
            Service : &nbsp;
          </label>
          <p>
            {_.get(businessActivityInfo, 'attributes.initial_data.service')}
          </p>
        </div>

        <div className="col-6 form-group">
          <label className="form-label">
            Business Line: {validateForm.renderMessage('business_line_id')}
          </label>
          <Select
            options={selectBusinessLineId}
            placeholder="Select Business Line"
            value={findBusinessLineValue}
            onChange={handleLineDropDownChange('business_line_id')}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">
            Philippine Standard Industrial Code:{' '}
            {validateForm.renderMessage('industrial_code')}
          </label>
          <input
            className="form-control"
            type="text"
            name="industrial_code"
            onChange={handleOnChange('industrial_code')}
            value={_.get(formData, 'industrial_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">
            Capital Amount: {validateForm.renderMessage('capital_amount')}
          </label>
          <NumberFormat
            name="capital_amount"
            id="capital_amount"
            placeholder="0.00"
            className="form-control"
            onValueChange={(values) => {
              const { value } = values;
              const props = {
                name: 'capital_amount',
                value,
              };
              handleChangeCapitalAmount(props);
            }}
            displayType="input"
            decimalScale={2}
            isNumericString
            allowNegative
            thousandSeparator
            allowLeadingZeros
            prefix="₱ "
            value={_.get(formData, 'capital_amount')}
            isAllowed={(values) => {
              const { value } = values;
              if (!value) return true;
              const val = new Decimal(value);
              const max = new Decimal(MAX_LIMIT);
              return value === undefined || val.lte(max);
            }}
          />
        </div>
        {filteredNecessaryFieldsList.map((item) => {
          const { quantity_matrix, ...detail } = item;
          const options = _.get(detail, 'options');
          const multiplier = _.get(detail, 'multiplier');

          if (options) {
            return (
              <div className='col-6 form-group' key={multiplier}>
                <label className="form-label">
                  {ucwords(multiplier.replace(/_/g, ' '))}{' '}
                </label>
                <Select
                  onChange={handleOfficeTypeDropDownChange(multiplier)}
                  options={selectOptions(options)}
                  value={
                    selectOptions(options).find(
                      (x) =>
                        _.get(detailFormData, multiplier) ===
                        _.get(x, 'value')
                    ) || ''
                  }
                />
              </div>
            )
          }

          return (
            <div className='col-6 form-group' key={multiplier}>
              <label className="form-label">
                {ucwords(multiplier.replace(/_/g, ' '))}{' '}
              </label>
              <input
                className="form-control"
                name={_.get(item, 'label')}
                id={_.get(item, 'label')}
                onChange={handleOnChangeDetail(multiplier)}
                value={_.get(detailFormData, multiplier) || ''}
                required
              />
            </div>
          );
        })}
        {!_.isEmpty(filteredQuantityMatrix) ? (
          filteredQuantityMatrix.map((item) => {
            const multiplier = _.get(item, 'multiplier', '');
            
            return (
              <React.Fragment>
                <div className='col-12 form-group mb-0'>
                  <label className='form-label mb-0 text-capitalize'>
                    {multiplier || ''}
                  </label>
                </div>
                <div className="w-100 border rounded-lg mx-3">
                  <table className="table table-borderless table-sm table-striped table-hover mb-0">
                    <thead>
                      <tr className="form-group">
                        <td className="col-4 text-center form-label border-right">Unit</td>
                        <td className="col-4 text-center form-label border-right">Capacity</td>
                        <td className="col-4 text-center form-label">Number of Units</td>
                      </tr>
                    </thead>
                    <tbody>
                      {item.quantity_matrix.map((quantityMatrixItem) => {
                        const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                        return (
                          <tr key={quantityMatrixMultiplier} className="border-top form-group">
                            <td className="col-4 text-left form-label border-right">
                              {_.get(quantityMatrixItem, 'unit')}
                            </td>
                            <td className="col-4 text-left form-label border-right">
                              {_.get(quantityMatrixItem, 'capacity')}
                            </td>
                            <td className="col-4 text-left form-label">
                              <NumberFormat
                                name={quantityMatrixMultiplier}
                                id={quantityMatrixMultiplier}
                                className="form-control"
                                onValueChange={(values) => {
                                  const { floatValue } = values;
                                  onChangeQuantityMatrix(quantityMatrixMultiplier, floatValue);
                                }}
                                displayType="input"
                                decimalScale={2}
                                thousandSeparator
                                allowLeadingZeros
                                isNumericString
                                value={_.get(formDataQuantityMatrix, `${quantityMatrixMultiplier}`)}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </React.Fragment>
            )
          })
          
        ) : (
          ''
        )}
      </div>
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          onClick={handleOnUpdate(formData)}
        >
          <span className="font-weight-bold">Submit</span>
        </button>
        <button
          type="button"
          onClick={() => closeUpdateModal()}
          className="mt-3 btn btn-dark"
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
      <hr />
    </div>
  );
}

BusinessActivityModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  businessActivityInfo: PropTypes.instanceOf(Object).isRequired,
  closeUpdateModal: PropTypes.instanceOf(Function).isRequired,
  handleOnUpdate: PropTypes.instanceOf(Function).isRequired,
  detailFormData: PropTypes.instanceOf(Object).isRequired,
  setDetailFormData: PropTypes.instanceOf(Function).isRequired,
  formDataQuantityMatrix: PropTypes.instanceOf(Object).isRequired,
  setFormDataQuantityMatrix: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BusinessActivityModal);
